/**
 * Widget title component to be optionally used by EmbedFeed and Storyblock
 * when `title` params is provided. Typically only renders if there are videos.
 */
export const WidgetTitle = ({ params }) => {
    return params.title ? (<div className="cy-title" role="presentation" style={{
            color: 'var(--title-color, inherit)',
            fontFamily: 'var(--title-font-family, inherit)',
            fontSize: `var(--title-font-size, ${params.title_size ?? 28}px)`,
            fontWeight: 'var(--title-font-weight, 500)',
            margin: 0,
            padding: '20px 10px',
            textAlign: `var(--title-text-align, ${params.title_alignment ?? 'left'})`,
        }}>
      {params.title}
    </div>) : null;
};
